// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.international-icon[data-v-f142be86] {\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  vertical-align: -5px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
